const Home = () => {
    return ( 
        <div>
            <h1>Cash Register Manager</h1>
            <p>Enter the bill amount and cash given by the customer and know minimum number of notes to return.</p>
        </div>
     );
}
 
export default Home;